import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bronxConfig } from "./data";

export default function TheBronxPage() {
  return <CityPageTemplate config={bronxConfig} />;
}